import { c as _c } from "react/compiler-runtime";
import { useDepartments } from "@/queries/department/department-queries";
import { useContactTopics } from "@/queries/helpdesk/helpdesk-queries";
export function useContactForm() {
  const $ = _c(3);
  const topicsQuery = useContactTopics();
  const departmentsQuery = useDepartments();
  let t0;
  if ($[0] !== departmentsQuery || $[1] !== topicsQuery) {
    t0 = {
      topicsQuery,
      departmentsQuery
    };
    $[0] = departmentsQuery;
    $[1] = topicsQuery;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}